// removed by extract-text-webpack-plugin
module.exports = {"content":"Modal-style__content__25Iuq"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Modal-style.scss
// module id = 3049
// module chunks = 62